export const EMPTY_LANGUAGE_EMOJI = '\u{1F3F3}\uFE0F';
export const getLanguageEmoji = (flags, iso) => flags[iso] ?? EMPTY_LANGUAGE_EMOJI;
export const getLocalizedLanguageName = (intl, iso) => intl.formatMessage({ id: iso, defaultMessage: iso });
export const getSegmentTranscriptionLanguages = (segment) => {
    const languages = [segment.audioLanguage];
    for (const setup of segment.translationSetup.languages) {
        if (!languages.includes(setup.iso)) {
            languages.push(setup.iso);
        }
    }
    return languages;
};
export const isSegmentTranslationLanguage = (segment, language) => language !== segment.audioLanguage
    && segment.translationSetup.languages.some((item) => item.iso === language);
